<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-else>
      <v-simple-table class="ma-5">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Produto</th>
              <th class="text-left">Quantidade</th>
              <th class="text-left">Código referência do fornecedor</th>
              <th class="text-left">Especificação</th>
              <th class="text-left">Observação interna</th>
              <th class="text-left">Observação externa</th>
            </tr>
          </thead>
          <tbody v-if="produtos.length > 0">
            <tr v-for="(produto, index) in produtos" :key="index">
              <td>
                <px-produto-descricao v-if="produto.produto"
                                      :especificacao="produto.especificacaoProduto"
                                      :produto="produto.produto"/>&nbsp;
                <span v-if="!produto.produto">
                  {{ produto.especificacaoProduto }}
                </span>
                <px-resumo-produto-dialog v-if="produto.produto"
                                          :produto="produto.produto"
                                          :unidade-medida="produto.unidadeMedida"/>
              </td>
              <td>
                {{ produto.quantidade | number(getCurrencyFormat(casasDecimaisItem(produto))) }}
                {{ produto.unidadeMedida.descricao }}
              </td>
              <td>
                {{ codigoFornecedor(produto) | naoInformado }}
              </td>
              <td>
                <template v-if="produto.especificacaoProduto">
                  <px-span-tooltip top :text="especificacao(produto)"
                                  :tooltip="produto.especificacaoProduto"/>
                </template>
                <template v-else>
                  Não informado
                </template>
              </td>
              <td>
                <template v-if="hasObservacaoInterna(produto)">
                  <px-span-tooltip
                    top
                    :text="observacaoInternaLabel(produto)"
                    :tooltip="observacaoInternaTooltip(produto)"/>
                </template>
                <template v-else>
                  Não informado
                </template>
              </td>
              <td>
                <template v-if="hasObservacaoExterna(produto)">
                  <px-span-tooltip
                    top
                    :text="observacaoExternaLabel(produto)"
                    :tooltip="observacaoExternaTooltip(produto)"/>
                </template>
                <template v-else>
                  Não informado
                </template>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <th colspan="6" class="text-body-1 text-center">
              <div>
                Não existem produtos nessa solicitação
              </div>
            </th>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { CasaDecimalUtils } from 'px-components';
import RequisicaoProdutoService from '../requisicoes-service';

export default {
  props: {
    requisicao: Object,
  },
  data() {
    return {
      produtos: [],
      loading: false,
    };
  },
  computed: {
    especificacao() {
      return item => Vue.filter('truncate')(item.especificacaoProduto, 30);
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    casasDecimaisItem() {
      return item => (item.produto ? item.produto.casasDecimais : null);
    },
    codigoFornecedor() {
      return item => (item.produto ? item.produto.codigoFornecedor : null);
    },
    observacaoInternaLabel() {
      return (produto) => {
        if (produto.observacaoInterna) {
          return Vue.filter('truncate')(produto.observacaoInterna, 15);
        }
        return Vue.filter('truncate')(produto.produto.observacaoInterna, 15);
      };
    },
    observacaoExternaLabel() {
      return (produto) => {
        if (produto.observacaoExterna) {
          return Vue.filter('truncate')(produto.observacaoExterna, 15);
        }
        return Vue.filter('truncate')(produto.produto.observacaoExterna, 15);
      };
    },
    observacaoInternaTooltip() {
      return produto => produto.observacaoInterna ?? produto.produto.observacaoInterna;
    },
    observacaoExternaTooltip() {
      return produto => produto.observacaoExterna ?? produto.produto.observacaoExterna;
    },
    hasObservacaoExterna() {
      return produto => (produto.produto && produto.produto.observacaoExterna)
      || produto.observacaoExterna;
    },
    hasObservacaoInterna() {
      return produto => (produto.produto && produto.produto.observacaoInterna)
      || produto.observacaoInterna;
    },
  },
  methods: {
    getProdutos() {
      this.loading = true;
      RequisicaoProdutoService.getProdutos(this.requisicao.id)
        .then(({ data }) => {
          this.produtos = data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getProdutos();
  },
};
</script>
